import { format, isValid } from 'date-fns';
import { fDateTime } from '../../../utils/formatTime';
import { safeJsonParse } from '../../../admin/api';

function safeDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  const normalizedValue =
    typeof value === 'string' && value.includes(' ') ? value.replace(' ', 'T') : value;
  const parsedDate = new Date(normalizedValue);

  return isValid(parsedDate) ? parsedDate : null;
}

export function formatValue(value, fallback = 'N/A') {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  return `${value}`;
}

export function formatDateTime(value, fallback = 'N/A') {
  if (!value) {
    return fallback;
  }

  return fDateTime(value) || fallback;
}

export function parseServerDateTime(value) {
  return safeDate(value);
}

export function formatServerDateTime(value) {
  const parsedDate = safeDate(value);

  if (!parsedDate) {
    return '';
  }

  return format(parsedDate, 'yyyy-MM-dd HH:mm:ss');
}

export function getSignalFlags(signal) {
  const isEscalatedToBroadcast = Number(signal?.attempt_count || 0) >= 3;
  const hasLinkedCase = Boolean(signal?.case_id);
  const hasBlock = signal?.status === 'active' && Boolean(signal?.block_expires_at);

  return {
    isEscalatedToBroadcast,
    hasLinkedCase,
    hasBlock,
    canResolve: signal?.status === 'active',
    canExtend: signal?.status === 'active',
    canRemoveBlock: hasBlock,
  };
}

export function buildTimelineItems(items, type) {
  return (items || []).map((row) => {
    const payload = safeJsonParse(row.payload, null);

    return {
      id: `${type}-${row.id}`,
      title: row.event_type || (type === 'case' ? 'Case event' : 'Signal event'),
      description: payload ? JSON.stringify(payload) : 'No structured payload returned',
      time: formatDateTime(row.created_at),
      color:
        row.event_type === 'resolved'
          ? 'success'
          : row.event_type === 'manual_block_removed'
            ? 'warning'
            : row.event_type?.includes('broadcast')
              ? 'error'
              : 'primary',
    };
  });
}
